import script from "./ListExam.vue?vue&type=script&lang=ts&setup=true"
export * from "./ListExam.vue?vue&type=script&lang=ts&setup=true"

import "./ListExam.vue?vue&type=style&index=0&id=5f601b2a&lang=css"

export default script